import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ImageFetch from "./ImageFetch";
import { useEffect, useState } from "react";

const traitsSettings = {
  center: false,
  items: 1,
  loop: false,
  margin: 14,
  nav: true,
  autoplay: false,
  autoWidth: true,
  dots: false,
};

export default ({selectedCategory,selectedStickerPack, addAssets,assetStickers,setSelectedCategory})=>{
    const [loader,setLoader] = useState(true)
    const [reRender,setRerender] = useState(false)
    useEffect(()=>{
        setLoader(true)
        setRerender(!reRender)
    },[selectedStickerPack])
    useEffect(()=>{
      if(!loader){
      const element = document.getElementById('caro').children[0]
      element.className = 'owl-stage-outer scroll'}
    },[loader])
    return ( 
        <div style = {{overflowX:"hidden"}} id="slider-block">
              <div className="slider-title">
                <h3>Select Traits:</h3>
                {!loader?<form className="tags">
                  {Object.keys(assetStickers.Male).map((option, index) => (
                    <label key={index} style = {selectedCategory==option?{backgroundColor:"#00a5a6"}:{backgroundColor:"rgb(2 36 36 / var(--tw-bg-opacity))"}} className="tag">
                      <input
                        type="checkbox"
                        checked={selectedCategory==option}
                        onChange={() => setSelectedCategory(option)}
                      />
                      {option}
                    </label>
                  ))}
                </form>:<></>}
              </div>
              {loader ? <div className="loader"></div> :<></>}
              <OwlCarousel
                id = "caro" className="artis-slider  owl-theme"
                {...traitsSettings}
              > 
              
                {selectedStickerPack.map((sticker,index) => {
                  return (
                  <ImageFetch 
                  addAssets={addAssets} 
                  link={sticker.image} 
                  incrementLoader = {()=>{
                    setLoader(false)
                    }} 
                  imagesLoaded={true} 
                  reRender={reRender} 
                  selectedCategory={selectedCategory}
                  key={index}
                  />
                  );
                })}
              </OwlCarousel>
            </div>   
    )
}